import * as React from "react"

function CopySvgComponent(props) {
  return (
    <svg
      data-name="Group 2459"
      xmlns="http://www.w3.org/2000/svg"
      width={15.531}
      height={19.396}
      {...props}
    >
      <path
        data-name="Path 26284"
        d="M10.55 3.392H1.533A1.534 1.534 0 000 4.925v12.938a1.534 1.534 0 001.533 1.533h9.017a1.534 1.534 0 001.533-1.533V4.925a1.539 1.539 0 00-1.533-1.533zm.457 14.467a.461.461 0 01-.461.461H1.529a.461.461 0 01-.461-.461V4.925a.461.461 0 01.461-.461h9.021a.461.461 0 01.461.461z"
        fill="#2555ef"
      />
      <path
        data-name="Path 26285"
        d="M13.998 0H4.981a1.534 1.534 0 00-1.533 1.533.536.536 0 001.073 0 .461.461 0 01.461-.461h9.016a.461.461 0 01.461.461v12.938a.461.461 0 01-.461.461.536.536 0 000 1.068 1.534 1.534 0 001.533-1.533V1.533A1.534 1.534 0 0013.998 0z"
        fill="#2555ef"
      />
    </svg>
  )
}

export default CopySvgComponent
